import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export const convertApnsToken = async (apnsToken: string): Promise<string> => {
  const functions = getFunctions();
  const convertToken = httpsCallable<
    { apnsToken: string },
    { fcmToken: string }
  >(functions, 'apnsFcmConversion-convertApnsToken');

  const { data } = await convertToken({ apnsToken });
  return data.fcmToken;
};
